import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Страницы
import ClientPresence from '../pages/CheckList/ClientPresence';
import ClientConsent from '../pages/CheckList/ClientConsent';
import CheckListSelection from '../pages/CheckList/CheckListSelection';
import ZoneCheck from '../pages/CheckList/ZoneCheck';

function App() {
    return (
        <Routes>
            <Route path=":orderId" element={<ClientPresence />} />
            <Route path=":orderId/client-consent" element={<ClientConsent />} />
            <Route path=":orderId/select-zones" element={<CheckListSelection />} />
            <Route path=":orderId/zone-check/:zoneName" element={<ZoneCheck />} />

        </Routes>
    );
}

export default App;
